import initialState from "../initialState";

import {
  CURATED_REGHUB_TOPICS_ARE_LOADING,
  CURATED_REGHUB_TOPICS_LOADED_WITH_ERROR,
  CURATED_REGHUB_TOPICS_HAVE_LOADED,
  GET_SINGLE_CURRENT_TOPIC_IS_LOADING,
  GET_SINGLE_CURRENT_TOPIC_LOADED_WITH_ERROR,
  GET_SINGLE_CURRENT_TOPIC_IS_LOADED,
  RESTART_TOPIC_MESSAGES,
  TOPIC_SUCCESS_MESSAGE_RAISED,
  TOPIC_ERROR_MESSAGE_RAISED,
} from "../actions/actionTypes";

export default function topicReducer(
  state = initialState.topicReducerState,
  action
) {
  switch (action.type) {
    case CURATED_REGHUB_TOPICS_ARE_LOADING: {
      return {
        ...state,
        curatedRegHubTopics: [],
        mySelectionTopics: [],
        curatedRegHubTopicsAreLoading: true,
        curatedRegHubTopicsHaveLoadedWithError: false,
      };
    }

    case CURATED_REGHUB_TOPICS_HAVE_LOADED: {
      return {
        ...state,
        curatedRegHubTopics: action.curatedRegHubTopics,
        mySelectionTopics: action.mySelectionTopics,
        curatedRegHubTopicsAreLoading: false,
        curatedRegHubTopicsHaveLoadedWithError: false,
      };
    }

    case CURATED_REGHUB_TOPICS_LOADED_WITH_ERROR: {
      return {
        ...state,
        curatedRegHubTopics: [],
        mySelectionTopics: [],
        curatedRegHubTopicsAreLoading: false,
        curatedRegHubTopicsHaveLoadedWithError: true,
      };
    }

    case GET_SINGLE_CURRENT_TOPIC_IS_LOADING: {
      return {
        ...state,
        singleTopic: {},
        singleTopicIsLoading: action.singleTopicIsLoading,
        singleTopicIsLoadedWithError: false,
      };
    }

    case GET_SINGLE_CURRENT_TOPIC_LOADED_WITH_ERROR: {
      return {
        ...state,
        singleTopic: {},
        singleTopicIsLoading: false,
        singleTopicIsLoadedWithError: true,
      };
    }

    case GET_SINGLE_CURRENT_TOPIC_IS_LOADED: {
      return {
        ...state,
        singleTopic: action.singleTopic,
        singleTopicIsLoading: false,
        singleTopicIsLoadedWithError: false,
      };
    }

    case RESTART_TOPIC_MESSAGES: {
      return {
        ...state,
        topicErrorMessage: "",
        topicSuccessMessage: "",
      };
    }

    case TOPIC_SUCCESS_MESSAGE_RAISED: {
      return {
        ...state,
        topicSuccessMessage: action.topicSuccessMessage,
      };
    }

    case TOPIC_ERROR_MESSAGE_RAISED: {
      return {
        ...state,
        topicErrorMessage: action.topicErrorMessage,
      };
    }

    default: {
      return state;
    }
  }
}
